import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material"
import Datatable from "../../../components/features/Datatable"
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import BsModal from "../../../components/common/BaseModal";
import { DeleteIconButton, EditIconButton } from "../../../../assets/common-svg/CommonSvg";
import DeleteModal from "../../../components/common/BaseModal/DeleteModal";
import DeliveryPartnersForm from "./deliveryPartnersForm";
import { deleteDeliveryPartner, disableAddModal, enableAddModal, fetchAllDeliveryPartners, selectBmrAddDeliveryPartnerModal, selectDeliveryPartnersAll } from "../../../slices/deliveryPartners";

const DeliveryPartners = () => {
    const dispatch = useDispatch()
    const addModal = useSelector(selectBmrAddDeliveryPartnerModal)
    const [rowData, setRowData] = useState(null)
    const [open, setOpen] = useState(false)
    const allDeliveryPartners = useSelector(selectDeliveryPartnersAll)

    const columns = [
        {
            id: 'name',
            name: 'Name',
            align: "center",

            selector: row => row.name,
            sortable: true
        },
        {
            id: 'type',
            name: 'Status',
            align: "center",
            selector: row => row.status == 1 ? <Typography className="text-[#369c50]">Active</Typography> : <Typography className="text-[#FF2023]">In-Active</Typography>,
            sortable: true
        },
        {
            name: 'Action',
            align: "center",
            selector: row => <Box key={row.id}>
                <Tooltip title="Edit" >
                    <span>
                        <IconButton
                            onClick={() => { setRowData(row), handleAddModal() }}
                        >
                            <EditIconButton
                                bgColor={"#C3C3C3"}
                            />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="Delete" >
                    <span>
                        <IconButton
                            onClick={() => { setRowData(row), setOpen(true) }}
                        >
                            <DeleteIconButton
                                bgColor={"#FA5151"}
                            />
                        </IconButton>
                    </span>
                </Tooltip>
            </Box>,
        },
    ];


    const fetchData = async () => {
        await dispatch(disableAddModal())
        await dispatch(fetchAllDeliveryPartners())
    }

    useEffect(() => {
        fetchData()
    }, []);
    const handleCloseModal = async () => {
        await dispatch(disableAddModal())
    }
    const handleAddModal = async () => {
        await dispatch(enableAddModal())
    }
    const removeDeliveryPartners = async () => {
        const { id } = rowData
        await dispatch(deleteDeliveryPartner({ id }))
        setOpen(false)
    }


    return <div className="!p-6">
        <div className="!p-4 mt-3 bg-white flex flex-col gap-4">
            <BsModal open={addModal} onClose={handleCloseModal} title={rowData ? "Edit Delivery/Logistics Partners" : "Add Delivery/Logistics Partners"}>
                <DeliveryPartnersForm editData={rowData} />
            </BsModal>
            <Datatable
                columns={columns}
                data={allDeliveryPartners}
                title="Delivery/Logistics Partners"
                searchPlaceholder="Search by Name"
                BtnComponent={<Button className="ml-2" onClick={() => (handleAddModal(), setRowData(null))}>Add New</Button>}
            // remote={false}
            // onServerSideChange={updateFilter}
            />
            <DeleteModal
                open={open}
                setClose={setOpen}
                title={"Are you sure you want to Delete ?"}
                buttonText={"Delete"}
                handleSuccess={removeDeliveryPartners}
            />
        </div>
    </div>
}
export default DeliveryPartners